import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';

import { AuthenticationService } from './_services';
import { User } from './_models';
import { BookService } from "./shared/book.service";
import { Book } from "./models/book.class";

declare let alertify: any;
declare let localforage: any;
declare let window: any;

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
	display = false;
	urlImage!: string;
	urlImage2!: string;
	selectedWord: any;
	currentUser?: User;
	listBook: Book[] = [];
	title = "learning-app";
	filteredBooks: Book[] = [];
	results: Book[] = [];
	bookCode!: Book;
	listBiletKeyWords!: any[];
	userInfo?: User;
	public sidebarMinimized = false;
	public navItems = [];
	listMenu = [];
	level1 = [];
	constructor(
		private service: BookService,
		private router: Router,
		private authenticationService: AuthenticationService
	) {
		this.authenticationService.currentUser!.subscribe(x => this.currentUser = x);
	}

	ngOnInit() {
		window.__static = document.querySelector('meta[name="url_static"]')?.getAttribute('content');
		this.getInfoUser();
		this.getBookDetailFromRouter();
	}

	getCdnImage(url : string) {
		let s = url || '';
		let fix = 'http://static.bilet.vn/static/';
		if (s.length > fix.length)
			s = window['__cdn_static'] + s.substr(fix.length);
		console.log(s);
		return s;
	}
	getInfoUser() {
		this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
	}
	getBookDetailFromRouter(): void {
		var booksOnline = this.service.getBooks();
		var products: any = (booksOnline as any).default;
		var listItem = [];
		const keys = Object.keys(products);
		for (const property in products) {
			listItem.push(products[property]);
		}
		this.listBook = listItem.map((item, index) => {
			var biletkeyword = item.biletkeywords;
			var keyword1: string;
			var keyword2: string;
			var book: string;
			var category: string;
			biletkeyword.forEach((it: any, idx: number) => {
				keyword1 = it.keyword1.keyword_en;
				keyword2 = it.keyword2.keyword_en;
				book = item.code;
				category = it.category;
				this.urlImage = this.imageProcessKeyword(
					keyword1,
					book + "/image/" + category + "/"
				);
				this.urlImage2 = this.imageProcessKeyword(
					keyword2,
					book + "/image/" + category + "/"
				);
				it.code = item.code;
				it.keyword1.urlKeyword1 = this.urlImage;
				it.keyword2.urlKeyword2 = this.urlImage2;
				this.filteredBooks.push(it);

			});
			item.biletcategory.forEach((o: any, idx: number) => {
				var urlIm = this.imageProcessKeyword(o.id, book + "/image/" + "/");
				item.biletcategory[idx].url = urlIm;
				item.biletcategory[
					idx
				].background = window.__static + `/static/${item.code}/image/background_stretch.png`;
			});

			return {
				...item,
				biletcategory: item.biletcategory,
			};
		});

		// this.listBook.find((i) => {
		//   if (i.code == code) {
		//     this.bookCode = i;
		//     return this.bookCode;
		//   }
		//   return;
		// });
		// this.listBiletKeyWords = this.bookCode.biletkeywords.map((o) => {
		//   if (o.category === id) {
		//     return o;
		//   }
		// });
		// this.filterBiletKeyWords = this.listBiletKeyWords.filter(function (el) {
		//   return el != null;
		// });
		// if (url === "demo") {
		//   if (this.filterBiletKeyWords.length > 10) {
		//     this.filterBiletKeyWords = this.filterBiletKeyWords.slice(0, 10);
		//   }
		// }


	}


	imageProcessKeyword(filename: string, sourcefolder: string) {
		var lowerfilename = filename;
		lowerfilename = lowerfilename.toLocaleLowerCase();

		var newfilename = lowerfilename;
		if (newfilename.indexOf(" ") >= 0) {
			newfilename = newfilename.replace(/ /g, "_");
		} else if (filename.indexOf("/") >= 0) {
			newfilename = filename.replace("/", "-");
		} else if (filename.indexOf("'") >= 0) {
			newfilename = filename.replace("'", "_");
		}
		var url = window.__static + `/static/${sourcefolder}${newfilename}.png`;
		return url;
	}

	toggleSideBar() {
		this.display = true;
	}
	onSelectSearch() {
		// var url = this.router.url.split("/")[1];
		// if (url === "demo") {
		// 	this.router.navigate([`demo/search-results`], { queryParams: { id: this.selectedWord.id, code: this.selectedWord?.code } });

		// } else if (url === "main") {
		// 	this.router.navigate([`main/search-results`], { queryParams: { id: this.selectedWord.id, code: this.selectedWord?.code } });
		// }

		location.href = `/main/search-results?code=${this.selectedWord?.code}&id=${this.selectedWord.id}`;
	}
	filterBooks(event: any) {
		let filtered: any[] = [];
		let query = event.query;

		for (let i = 0; i < this.filteredBooks.length; i++) {
			let book = this.filteredBooks[i];
			if (book?.keyword1?.keyword_en.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				book.key = 'key1';
				book.label = book?.keyword1?.keyword_en;
				filtered.push(book);
			} else if (book?.keyword1?.keyword_vn.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				book.key = 'key1';
				book.label = book?.keyword1?.keyword_vn;
				book.index = i;

				filtered.push(book);
			} else if (book?.keyword2?.keyword_vn.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				book.key = 'key2';
				book.label = book?.keyword2?.keyword_vn;
				book.index = i;
				filtered.push(book);
			} else if (book?.keyword2?.keyword_en.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				book.key = 'key2';
				book.index = i;
				book.label = book?.keyword2?.keyword_en;
				filtered.push(book);
			}

		}

		this.results = filtered;
	}

	toggleMinimize(e: any) {
		this.sidebarMinimized = e;
	}

	toggleFullScreen() {
		if (!document.fullscreenElement) {
			document.documentElement.requestFullscreen();
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			}
		}
	}

	login() {
		if (!this.authenticationService.currentUser) {
			this.router.navigate(['/login']);
		}
	}

	logout() {
		var self = this;
		alertify.confirm('Logout', 'Bạn chắc chắn muốn thoát?',
			function() {
				alertify.success('Thoát tài khoản thành công');
				self.authenticationService.logout(function() {
					console.log('Go to login');
					//self.router.navigate(['/login']);
					location.href = '/login'
				});
			}
			, function() {
				//alertify.error('Cancel') 
			});
	}
}
